import { Link } from 'react-router-dom';

import { useT } from '../i18n/LanguageProvider';
import type { ServiceArea } from '../types/content';

interface Props {
  service: ServiceArea;
  featured?: boolean;
}

export default function ServiceCard({ service, featured }: Props) {
  const t = useT();

  return (
    <article className={featured ? 'card featured' : 'card'}>
      <span className="num">{service.num}</span>
      <h3>{service.title}</h3>
      <p>{service.summary}</p>
      <ul>
        {service.what.slice(0, 4).map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <div className="card-foot">
        <Link className="textlink" to={`/tjanster#${service.id}`}>
          {t.common.readMore}
        </Link>
      </div>
    </article>
  );
}
